import { withStyles } from '@material-ui/core';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import withQuerySync from '@/hocs/withQuerySync';

import queryDuck from '../ducks/query';
import {
  getArchiveId,
  getArchiveStoreId,
  getReconciliationError,
  getReconciliationIds,
  getReconciliationTotalCount,
  getStoreId,
  isLoadingReconciliation,
} from '../selectors';
import ReconciliationRefunds from './component';
import styles from './styles';

const mapStateToProps = state => {
  const storeId = getStoreId(state);
  const archiveId = getArchiveId(state);
  const archiveStoreId = getArchiveStoreId(state);

  return {
    error: getReconciliationError(state),
    reconciliationIds: getReconciliationIds(state),
    isLoading: isLoadingReconciliation(state),
    totalCount: getReconciliationTotalCount(state),
    storeId,
    archiveId,
    archiveStoreId,
  };
};

export default compose(
  withQuerySync(queryDuck),
  connect(mapStateToProps),
  withStyles(styles),
)(ReconciliationRefunds);
